<template>
  <div class="order_detail_wrapper">
    <div class="content">
      <div class="common flex-row">
        <div class="left">
          <div class="basic-info">
            <div class="img-wrapper">
              <el-image :src="titlePrefix" />
            </div>
            <div>
              <div class="code">
                <span style="display: inline-block; width: 15em;">销售订单号：{{ orderCode }}</span>
                <span :class="`status-${detailInfo.status}`">
                  {{ detailInfo.statusDesc }}
                </span>
              </div>
              <div class="customer">{{ detailInfo.customerName }}</div>
            </div>
          </div>
          <el-tabs v-model="activeKey" @change="handleActiveChange">
            <el-tab-pane label="订单信息" name="1"></el-tab-pane>
            <el-tab-pane label="日志动态" name="2"></el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <template v-if="activeKey === '1'">
        <div class="common">
          <div class="title gap-12">基本信息</div>
          <el-descriptions :column="3">
            <el-descriptions-item label="销售模式">{{'-'}}</el-descriptions-item>
            <el-descriptions-item label="业务类型">{{
              detailInfo.businessTypeDesc | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="关联合同">
              <span>-</span>
            </el-descriptions-item>
            <el-descriptions-item label="客户抬头">{{
              detailInfo.customerName | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="订单来源">{{
              detailInfo.sourceTypeDesc | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="发票类型">{{
              detailInfo.invoiceTypeDesc | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="是否含税">{{'-'}}</el-descriptions-item>
            <el-descriptions-item label="结算方式">{{
              detailInfo.settleWayDesc | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="订单确认人">{{
              detailInfo.orderConfirmUserName | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="客户联系人">{{
              detailInfo.customerContactName | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="联系人电话">{{
              detailInfo.customerContactPhone | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="联系人邮箱">{{
              detailInfo.customerContactEmail | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="创建时间">{{
              formatDate(detailInfo.createTime)
            }}</el-descriptions-item>
            <el-descriptions-item label="对方单据号" :span="2">{{
              detailInfo.outOrderCode | setEmpty
            }}</el-descriptions-item>
            <el-descriptions-item label="收货信息" :span="3">{{
              `${detailInfo.receiverName || ''}_${detailInfo.receiverPhone || ''}_${detailInfo.receiverProvinceName || ''}${detailInfo.receiverCityName || ''}${detailInfo.receiverAreaName || ''}${detailInfo.receiverDetailAddress || ''}` || '--'
            }}</el-descriptions-item>
            <el-descriptions-item label="备注">{{
              detailInfo.remark | setEmpty
            }}</el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="common">
          <div class="title gap-12">物资信息</div>
          <vxe-grid
            ref="xGrid"
            size="small"
            auto-resize
            resizable
            border="inner"
            align="left"
            highlight-current-row
            highlight-hover-row
            show-overflow
            show-footer
            :columns="columns"
            :data="detailInfo.orderGoodsList"
            :footer-method="footerMethod"
            :merge-footer-items="footerItems">
            <template #imageList="{ row }">
              <span v-if="row.image && row.image.split(',').length > 0">
                <span v-for="(img, i) in row.image.split(',')" :key="'img-'+i">
                  <el-image v-if="i < 2" style="width: 32px; height: 32px; margin-right: 5px;" :src="img" :preview-src-list="row.image.split(',')" />
                </span>
                <span v-if="row.image.split(',').length > 2" style="color:#3182bd; margin-left: 2px;">...</span>
              </span>
              <span v-else>暂无图片</span>
            </template>
            <template slot="empty">
              <el-empty :image-size="100" description="暂无数据"></el-empty>
            </template>
          </vxe-grid>
        </div>
      </template>
      <template v-if="activeKey === '2'">
        <div class="common">
          <TableWithPagination :columnList="logColumns" :tableData="logData" />
        </div>
      </template>
    </div>
    <BottomPanel>
      <el-button type="default" @click="() => $router.back()" >返回</el-button>
    </BottomPanel>
  </div>
</template>
<script>
import * as Moment from 'dayjs';
import TableWithPagination, {
  TablePaginationMixin,
} from '@/components/common/TableWithPagination';
import { queryOrderDetail, orderLogs } from '@/api/pickUpOrders';
import setTableCols from './configs';
import { logTypes } from '@/model/logTypes';
import { dateFormat } from '@/utils/dateFormat.js';

export default {
  name: 'sale_contract_detail',
  mixins: [TablePaginationMixin],
  components: {
    TableWithPagination,
  },
  props: {
    tenantId: {
      type: String,
    },
    orderCode: {
      type: String,
    },
    id: {
      type: String,
    },
  },
  filters: {
    setEmpty (val) {
      return val ? val : '--';
    },
  },
  data () {
    return {
      titlePrefix: require('@/assets/title_prefix.svg'), // eslint-disable-line
      activeKey: '1',
      detailInfo: {
        orderGoodsList: [],
      },
      columns: setTableCols.call(this, 'detail'),
      logData: [],
      logColumns: [],
      logColumns1: [
        {
          prop: 'logType',
          label: '事项类型',
          width: '300px',
          tooltip: true,
          render: (h, { row }) => {
            let val = '--';

            for (let v of logTypes) {
              if (v.value === row.logType) {
                val = v.label;
                break;
              }
            }

            return h('span', val);
          },
        },
        {
          prop: 'createTime',
          label: '时间',
          width: '300px',
          tooltip: true,
        },
        {
          prop: 'content',
          label: '日志内容',
          tooltip: true,
        },
      ],
      logColumns2: [
        {
          prop: 'eventTypeDesc',
          label: '事项类型',
          width: '300px',
          tooltip: true,
        },
        {
          prop: 'createTime',
          label: '时间',
          width: '300px',
          tooltip: true,
          format: (val) => val && dateFormat(val).format('YYYY-MM-DD HH:mm:ss'),
        },
        {
          prop: 'content',
          label: '日志内容',
          tooltip: true,
        },
      ],
      footerItems: [{ row: 0, col: 1, rowspan: 1, colspan: 30 }],
    };
  },
  created () {
    this.getOrderDetail();
    this.getLog();
  },
  methods: {
    formatDate (text) {
      return text ? Moment(text).format('YYYY-MM-DD HH:mm:ss') : '';
    },
    convertToName (enums, value) {
      let label = '--';

      for (let v of enums) {
        if (Number(v.value) === Number(value)) {
          label = v.label;
          break;
        }
      }

      return label;
    },
    handleActiveChange (v) {
      this.activeKey = v;
    },
    getOrderDetail () {
      const query = this.$route.query;
      queryOrderDetail({
        findOrderGoodsFlag: true,
        id: query.id,
        tenantId: this.tenantId,
      }).then(({ body }) => {
        this.detailInfo = body || {};
        this.detailInfo.orderGoodsList = body?.orderGoodsList || [];
      });
    },
    getLog () {
      this.logColumns = this.logColumns2;
      orderLogs({
        businessId: this.id,
        businessType: 'SALE_ORDER',
        module: 'SALE',
        orderBy: [{
          orderByType: 'DESC',
          orderByProperty: 'lastUpdateTime',
        }],
        pageFlag: false,
      }).then(({ body }) => {
        this.logData = body?.list || [];
      });
    },
    footerMethod ({ data }) {
      if (!data.length) {
        return [];
      }

      let totalAmount = 0;
      let totalPrice = 0;

      data.forEach((v) => {
        totalAmount += Number(v.quantity);
        totalPrice += Number(v.taxPrice * 100 * v.quantity);
      });

      return [['合计', `数量：${totalAmount},  总金额：${(totalPrice / 100).toLocaleString('en-US', { minimumFractionDigits: 2 })}`]];
    },
  },
};
</script>
<style lang="scss" scoped>
@mixin tag_round() {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: normal;
}
.order_detail_wrapper {
  /deep/ .el-tabs__header {
    margin-bottom: 0;
  }
  height: 100%;
  display: flex;
  flex-direction: column;

  .content {
    flex: 1;
    padding: 8px 0 0;
    overflow: auto;

    .gap-12 {
      margin-bottom: 12px;
    }

    .common {
      background-color: #fff;
      padding: 12px;
      margin-bottom: 6px;

      &.flex-row {
        display: flex;
        justify-content: space-between;
        padding-right: 0;
        padding-bottom: 0;

        .left {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .basic-info {
            display: flex;
            align-items: center;

            .img-wrapper {
              width: 40px;
              height: 40px;
              background-color: #E2F3FE;
              border-radius: 4px;
              margin-right: 6px;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            .code {
              font-size: 14px;
              color: #929AA6;
              /**
              * 订单状态【0->草稿 1->待审核 2->已驳回 3->执行中 4->已取消 5->已完成 6->待确认 7->已关闭】
              */
              .status-0,
              .status-4,
              .status-7 {
                @include tag_round();
                color: #1F2733;
                background-color: #F2F4F7;
              }

              .status-2 {
                @include tag_round();
                background-color: #FEE9E5;
                color: #FF5959;
              }

              .status-1,
              .status-3,
              .status-6 {
                @include tag_round();
                background-color: #E2F3FE;
                color: #237FFA;
              }

              .status-5 {
                @include tag_round();
                background-color: #E5FEEB;
                color: #14CA64;
              }
            }

            .customer {
              font-size: 16px;
              font-weight: 600;
            }
          }

          /deep/ .ant-tabs-bar {
            margin: 0;

            .ant-tabs-nav {
              .ant-tabs-tab {
                margin-right: 16px;
              }
            }
          }
        }
      }

      .title {
        font-weight: bold;
      }
    }
  }

  /deep/ .el-descriptions-item__content {
    overflow: hidden;
    word-break: keep-all;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
